require('./portal_vue/src/main.js')
